













import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import { gameStatus } from '@/model/game';

@Component({
  computed: {
    ...mapGetters({
      gameStatus: 'game/getGameState'
    })
  },
  methods: {
    ...mapActions('grid', ['setEmptyGrid', 'hideAllCell']),
    ...mapActions('game', ['startGame', 'stopGame'])
  }
})
export default class Finish extends Vue {
  private loseStatus = gameStatus.LOSE;
  private winStatus = gameStatus.WIN;
}
